import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-smart-color-form',
  templateUrl: `./smart-color-form.component.html`,
  styleUrls: [`./smart-color-form.component.css`]
})
export class SmartColorFormComponent {
  @Output()
  submitForm = new EventEmitter();

  @Output()
  deleteColor = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  @Input()
  colors: string[] = [];

  @Input()
  index: number;

  @Input()
  editingSolidColor: boolean;
}
